<template>
  <div class="footer-shell border-t bg-white px-4 py-3 md:px-6 md:py-4">
    <div
      class="flex flex-col-reverse gap-3 md:flex-row md:items-center md:justify-between"
    >
      <button
        class="w-full rounded-lg bg-gray-100 px-3 py-2 text-sm text-[#2e234b] disabled:opacity-50 md:w-auto"
        :disabled="!canGoBack"
        @click="$emit('back')"
      >
        {{ $t("ticketPurchase.actions.back") }}
      </button>

      <div class="flex w-full items-center gap-3 md:w-auto">
        <button
          v-if="activeStep === 'tickets'"
          class="w-full rounded-lg bg-[#2e234b] px-4 py-2 text-sm text-white disabled:opacity-50 md:w-auto"
          :disabled="totalTickets === 0"
          @click="$emit('next')"
        >
          {{ $t("ticketPurchase.actions.next") }}
        </button>

        <button
          v-else-if="activeStep === 'services'"
          class="w-full rounded-lg bg-[#2e234b] px-4 py-2 text-sm text-white md:w-auto"
          @click="$emit('next')"
        >
          {{ $t("ticketPurchase.actions.next") }}
        </button>

        <button
          v-else-if="activeStep === 'guest-details'"
          class="w-full rounded-lg bg-[#2e234b] px-4 py-2 text-sm text-white disabled:opacity-50 md:w-auto"
          :disabled="!isGuestFormValid"
          @click="$emit('review')"
        >
          {{ $t("ticketPurchase.actions.reviewAndPay") }}
        </button>

        <button
          v-else-if="activeStep === 'payment'"
          class="w-full min-w-[170px] rounded-lg bg-gradient-to-r from-[#4b2d83] via-[#7b1fa2] to-[#ec1379] px-4 py-2 text-sm text-white shadow-[0_3px_10px_rgba(44,18,71,0.18)] disabled:opacity-50 md:w-auto"
          @click="$emit('payNow')"
        >
          {{
            checkoutStatus
              ? $t("ticketPurchase.actions.paymentSent")
              : $t("ticketPurchase.actions.payNow")
          }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TicketFlowStep } from "./types";

defineProps<{
  activeStep: TicketFlowStep;
  canGoBack: boolean;
  totalTickets: number;
  isGuestFormValid: boolean;
  checkoutStatus: string | null;
}>();

defineEmits<{
  (e: "back" | "next" | "review" | "payNow"): void;
}>();
</script>

<style scoped>
.footer-shell {
  padding-bottom: calc(0.75rem + env(safe-area-inset-bottom));
}

@media (min-width: 768px) {
  .footer-shell {
    padding-bottom: 1rem;
  }
}
</style>
